module.exports = __webpack_public_path__ + "img/01020201.d2e25155.svg";